import {
    Box,
    Typography,
} from '@mui/material'
import {Image} from 'antd'
import QuickCashBanner from '../../../assets/personal-loan/quickcash-banner.png'
import AppGallery from '../../../assets/download/download_appgallery.png'
import GooglePlay from '../../../assets/download/download_googleplay.png'
import AppStore from '../../../assets/download/download_appstore.png'
import Logo from '../../../assets/download/logo_icon.png'
import { GOOGLE_PLAY_STORE_LINK, APP_STORE_LINK, APP_GALLERY_LINK, App_Language_key } from '../../../common/config'
import { useTranslation } from 'react-i18next'
import { isTablet } from 'react-device-detect'

export const SMQuickCash: React.FC = () => {

    const { t } = useTranslation()

    // ======================= GooglePlay
    const clickGooglePlay = () => {
        window.open(GOOGLE_PLAY_STORE_LINK)
    }

    // ======================= AppStore
    const clickAppStore = () => {
        window.open(APP_STORE_LINK)
    }

    // ======================= AppGallery
    const clickAppGallery = () => {
        window.open(APP_GALLERY_LINK)
    }

    // ======================= VIEWS
    return (
        <Box
            sx={{
                width: '100%',
            }}
        >
            <Box sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'row',
                paddingTop: '80px',
                paddingLeft: isTablet ? '40px' : '60px',
                paddingRight: isTablet ? '40px' : '60px',
            }}>
                <Box sx={{
                    flex: '1',
                    display: 'flex',
                    flexDirection: 'column',
                    paddingRight: isTablet ? '20px' : '40px',
                }}>
                    <Typography fontSize={32} fontWeight={700} color={'#141F39'}>
                        {t('t209')}
                    </Typography>

                    <Typography fontSize={16} fontWeight={400} color={'#6B6B6B'} paddingTop={'16px'}>
                        {t('t210')}
                    </Typography>

                    <Box sx={{
                        paddingTop: '20px',
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'end'
                    }}>
                        <Image src={Logo} width={50} height={50} alt='' preview={false}></Image>
                        <Box sx={{paddingLeft: '8px', width: sessionStorage.getItem(App_Language_key) === 'ms' ? '350px' : '320px' }}>
                            <Typography fontSize={16} fontWeight={600} color={'#141F39'}>
                                {t('t211')}
                            </Typography>
                        </Box>
                    </Box>
                    
                    <Box sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        paddingTop: '16px'
                    }}>
                        <Box
                            onClick={clickGooglePlay}
                            sx={{
                                cursor: 'pointer',
                            }}>
                            <Image src={GooglePlay} width={150} height={50} alt='' preview={false}></Image>
                        </Box>

                        <Box sx={{
                            width: '10px'
                        }}></Box>

                        <Box
                            onClick={clickAppStore}
                            sx={{
                                cursor: 'pointer',
                            }}>
                            <Image src={AppStore} width={150} height={50} alt='' preview={false}></Image>
                        </Box>

                        <Box sx={{
                            width: '10px'
                        }}></Box>

                        <Box
                            onClick={clickAppGallery}
                            sx={{
                                cursor: 'pointer',
                            }}>
                            <Image src={AppGallery} width={150} height={50} alt='' preview={false}></Image>
                        </Box>
                    </Box>

                </Box>
                <Image src={QuickCashBanner} width={isTablet ? 460 : 636} height={isTablet ? 396 : 548} style={{borderRadius: '10px'}} alt='' preview={false}></Image>
            </Box>

        </Box >
    )
}

// ======================= EXPORT
export default SMQuickCash
